module.exports = __webpack_public_path__ + "assets/a7529a84226fee3c83a8ca43d3ee5656.png";